import { render } from "./calling.vue?vue&type=template&id=48513f88&scoped=true&lang=pug"
import script from "./calling.vue?vue&type=script&lang=js"
export * from "./calling.vue?vue&type=script&lang=js"

import "./calling.vue?vue&type=style&index=0&id=48513f88&lang=stylus&scoped=true"

import exportComponent from "/mnt/jenkins/workspace/taoziprod-platform-webh5-remoteinquiry-master-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48513f88"]])

export default __exports__